import env from 'react-dotenv';

const config = {
    Model : {
        name: env.MODEL_NAME || 'jdpconsumersearch'
    },
    Cache: {
        expiry: env.CACHE_EXPIRY || 300000, // 5 minutes
    },
    SuggestionAPI: {
        url: env.SUGGESTION_API_URL || 'http://localhost:3001/api/suggestions',
        apiKey: env.SUGGESTION_API_KEY || 'test',
        timeout: env.SUGGESTION_API_TIMEOUT || 5000,
        retries: env.SUGGESTION_API_RETRIES || 3,
    },
    FilterAPI: {
        url: env.FILTER_API_URL || 'http://localhost:3002/api/filters',
        apiKey:  env.FILTER_API_KEY || 'test',
        timeout: env.FILTER_API_TIMEOUT || 5000,
        retries: env.FILTER_API_RETRIES || 3,
    },
    KeyFeaturesAPI: {
        url: env.KEY_FEATURES_API_URL || 'http://localhost:3003/api/features',
        apiKey: env.KEY_FEATURES_API_KEY || 'test',
        timeout: env.KEY_FEATURES_API_TIMEOUT || 5000,
        retries: env.KEY_FEATURES_API_RETRIES || 3,
    },
    IntelligentCategoryAPI: {
        url: env.INTELLIGENT_CATEGORY_API_URL || 'http://localhost:3004/api/categories',
        apiKey: env.INTELLIGENT_CATEGORY_API_KEY || 'test',
        timeout: env.INTELLIGENT_CATEGORY_API_TIMEOUT || 5000,
        retries: env.INTELLIGENT_CATEGORY_API_RETRIES || 3,
    },
    ConversationAPI: {
        url: env.CONVERSATION_API_URL || 'http://localhost:3006/api/conversation',
        apiKey: env.CONVERSATION_API_KEY || 'test',
        timeout: env.CONVERSATION_API_TIMEOUT || 5000,
        retries: env.CONVERSATION_API_RETRIES || 3,
    },
    InventoryAPI: {
        url: env.INVENTORY_API_URL || 'http://localhost:3006/api/conversation',
        apiKey: env.INVENTORY_API_KEY || 'test',
        timeout: env.INVENTORY_API_TIMEOUT || 5000,
        retries: env.INVENTORY_API_RETRIES || 3,
    }
};

export default config;